export default __webpack_public_path__ + "static/settings-ad3405d125c81cc83695f10d49b51ae3.webp";